import { cssVar } from '../../theme/variables.js';
import { styled } from 'styled-components';
import { mediaHover } from '../../constants/styled-utils.js';

const SidebarActionButton = styled.button.withConfig({
  displayName: "ButtonExpandCollapse__SidebarActionButton",
  componentId: "sc-5e1cc8af-0"
})([
  `position:relative;color:`,
  `;border-radius:4px;display:flex;align-items:center;justify-content:center;cursor:pointer;width:20px;height:20px;transition:color 0.2s,background-color 0.2s,opacity 0.2s;outline:none !important;`,
  `{&:hover:enabled{background-color:#e8e2fe;color:`,
  `;}}&:disabled{color:`,
  `;opacity:0.5;}`
], cssVar["color-text-quaternary"], mediaHover, cssVar["color-app-primary"], cssVar["color-text-placeholder"]);

export { SidebarActionButton };
//# sourceMappingURL=ButtonExpandCollapse.js.map
